module.exports = __webpack_public_path__ + "static/media/penguinbackgroundlight.94bc5d90.jpg";